import { Outlet } from "react-router-dom";
import CosmosHeader from "./CosmosHeader";

const CosmosLayout = () => {
    return (
        <>
            <CosmosHeader/>
            <main>
                <Outlet/>
            </main>
        </>
    )
}

export default CosmosLayout
;